import React from 'react';
import logo from '../../logo_bw.svg';

export const navigationContextControlMarkup = (
  <div className="ContextControl">
    <img height={25} src={logo} />
  </div>
);
